import { Link } from 'react-router-dom';
import Navbar from '../home/components/Navbar';
import Footer from '../home/components/Footer';
import WhatsAppButton from '../../components/feature/WhatsAppButton';
import SchemaOrg from '../../components/feature/SchemaOrg';
import PriceSimulator from '../../components/feature/PriceSimulator';
import { useEffect } from 'react';

export default function LivraisonDernierKilometreParisPage() {
  useEffect(() => {
    document.title = 'Livraison Dernier Kilomètre Paris | Enjeux & Solutions Logistiques';
    
    const metaTags = [
      { name: 'description', content: 'Découvrez les enjeux de la livraison dernier kilomètre à Paris et nos solutions logistiques professionnelles. Transport urbain optimisé, livraison rapide et écologique pour les entreprises parisiennes.' },
      { name: 'keywords', content: 'livraison dernier kilomètre Paris, logistique urbaine Paris, livraison professionnelle, transport dernier kilomètre, logistique Paris' },
      { name: 'geo.region', content: 'FR-75' },
      { name: 'geo.placename', content: 'Paris' },
      { name: 'geo.position', content: '48.8566;2.3522' },
      { name: 'twitter:card', content: 'summary_large_image' },
      { name: 'twitter:title', content: 'Livraison Dernier Kilomètre Paris | Enjeux & Solutions Logistiques' },
      { name: 'twitter:description', content: 'Découvrez les enjeux de la livraison dernier kilomètre à Paris et nos solutions logistiques professionnelles.' }
    ];

    metaTags.forEach(({ name, content }) => {
      let meta = document.querySelector(`meta[name="${name}"]`);
      if (!meta) {
        meta = document.createElement('meta');
        meta.setAttribute('name', name);
        document.head.appendChild(meta);
      }
      meta.setAttribute('content', content);
    });

    let canonical = document.querySelector('link[rel="canonical"]') as HTMLLinkElement;
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.rel = 'canonical';
      document.head.appendChild(canonical);
    }
    canonical.href = 'https://transporteurexpressidf.fr/blog/livraison-dernier-kilometre-paris';
  }, []);

  const relatedArticles = [
    {
      slug: 'transport-urgent-weekend-paris',
      title: 'Transport urgent le week-end à Paris : comment ça marche ?',
      image: 'https://public.readdy.ai/ai/img_res/b2af9088791b49d22f619a9d147cd532.jpg'
    },
    {
      slug: 'choisir-transporteur-paris-guide',
      title: 'Comment choisir son transporteur à Paris : guide complet',
      image: 'https://readdy.ai/api/search-image?query=professional%20transport%20company%20selection%20guide%20Paris%20logistics%20comparison%20checklist%20business%20decision%20making%20modern%20office%20setting&width=400&height=250&seq=related2&orientation=landscape'
    },
    {
      slug: 'transport-colis-paris',
      title: 'Comment envoyer un colis rapidement à Paris ?',
      image: 'https://readdy.ai/api/search-image?query=professional%20courier%20delivering%20package%20in%20Paris%20streets%20with%20motorcycle%20fast%20delivery%20service%20modern%20urban%20logistics%20parcel%20box%20in%20hands%20efficient%20transport&width=400&height=250&seq=related3&orientation=landscape'
    }
  ];

  return (
    <>
      <SchemaOrg 
        type="article" 
        data={{
          headline: 'Livraison Dernier Kilomètre à Paris : Enjeux et Solutions',
          datePublished: '2024-01-20',
          dateModified: '2024-01-20',
          author: 'Speed Transport Paris',
          description: 'Découvrez les enjeux de la livraison dernier kilomètre à Paris et nos solutions logistiques professionnelles pour optimiser vos livraisons urbaines.'
        }}
      />
      <Navbar />
      <WhatsAppButton phoneNumber="0631012910" />

      <div className="min-h-screen bg-white">
        {/* Hero Section */}
        <section className="relative bg-gradient-to-br from-teal-500 to-emerald-600 text-white py-16">
          <div className="absolute inset-0 bg-gradient-to-b from-black/20 via-black/10 to-black/20"></div>
          <div className="container mx-auto px-4 relative z-10">
            <nav className="mb-6">
              <ol className="flex items-center space-x-2 text-sm text-white/80">
                <li><Link to="/" className="hover:text-white transition-colors">Accueil</Link></li>
                <li><i className="ri-arrow-right-s-line"></i></li>
                <li><Link to="/blog" className="hover:text-white transition-colors">Blog</Link></li>
                <li><i className="ri-arrow-right-s-line"></i></li>
                <li className="text-white font-medium">Livraison Dernier Kilomètre</li>
              </ol>
            </nav>
            <div className="max-w-4xl">
              <span className="inline-block px-4 py-2 bg-white/20 backdrop-blur-sm text-white text-sm font-medium rounded-full mb-4">
                Logistique Urbaine
              </span>
              <h1 className="text-4xl md:text-5xl font-bold mb-6">
                Livraison Dernier Kilomètre à Paris : Enjeux et Solutions
              </h1>
              <div className="flex items-center space-x-6 text-white/90">
                <span className="flex items-center">
                  <i className="ri-calendar-line mr-2"></i>
                  20 janvier 2024
                </span>
                <span className="flex items-center">
                  <i className="ri-time-line mr-2"></i>
                  8 min de lecture
                </span>
              </div>
            </div>
          </div>
        </section>

        {/* Featured Image */}
        <section className="container mx-auto px-4 -mt-12 relative z-10">
          <div className="max-w-5xl mx-auto">
            <div className="relative w-full h-96 rounded-xl overflow-hidden shadow-2xl">
              <img
                src="https://readdy.ai/api/search-image?query=last%20mile%20delivery%20logistics%20in%20Paris%20urban%20setting%20professional%20courier%20with%20electric%20vehicle%20modern%20city%20streets%20efficient%20transport%20sustainable%20delivery%20solution%20clean%20background&width=1200&height=600&seq=hero-dernier-kilometre&orientation=landscape"
                alt="Livraison dernier kilomètre à Paris - Solutions logistiques urbaines"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>
        </section>

        {/* Article Content */}
        <article className="container mx-auto px-4 py-16">
          <div className="max-w-4xl mx-auto">
            {/* Introduction */}
            <div className="prose prose-lg max-w-none mb-12">
              <p className="text-xl text-gray-700 leading-relaxed mb-6">
                La <strong>livraison dernier kilomètre à Paris</strong> représente l'étape finale et la plus critique de la chaîne logistique. Dans une métropole dense comme Paris, ce segment représente jusqu'à 30% du coût total de transport et constitue un défi majeur pour les entreprises. Découvrez les enjeux et les solutions innovantes pour optimiser vos <strong>livraisons urbaines à Paris</strong>.
              </p>
            </div>

            {/* Section 1 */}
            <section className="mb-12">
              <h2 className="text-3xl font-bold text-gray-900 mb-6 flex items-center">
                <a href="#enjeux-dernier-kilometre" id="enjeux-dernier-kilometre" className="hover:text-teal-600 transition-colors">
                  Qu'est-ce que le dernier kilomètre en logistique ?
                </a>
              </h2>
              <p className="text-gray-700 leading-relaxed mb-4">
                Le <strong>dernier kilomètre</strong> désigne la dernière étape du parcours d'une marchandise, du centre de distribution jusqu'au destinataire final. À Paris, cette phase est particulièrement complexe en raison de la densité urbaine, des restrictions de circulation et des attentes élevées des clients en matière de rapidité et de flexibilité.
              </p>
              <p className="text-gray-700 leading-relaxed mb-6">
                Pour les entreprises parisiennes, maîtriser la <strong>logistique urbaine à Paris</strong> est devenu un avantage concurrentiel majeur. Les clients B2B et B2C exigent désormais des livraisons rapides, fiables et traçables, souvent dans des créneaux horaires précis. Pour en savoir plus sur nos services, consultez notre <Link to="/transport-paris" className="text-teal-600 font-semibold hover:text-teal-700">page transport à Paris</Link>.
              </p>

              <div className="bg-teal-50 border-l-4 border-teal-500 p-6 rounded-r-lg mb-6">
                <h3 className="text-xl font-bold text-gray-900 mb-3 flex items-center">
                  <i className="ri-lightbulb-line text-teal-600 mr-2"></i>
                  Le saviez-vous ?
                </h3>
                <p className="text-gray-700">
                  À Paris, le dernier kilomètre représente en moyenne 41% du temps total de livraison et génère 25% des émissions de CO2 liées au transport de marchandises. C'est pourquoi les solutions de <strong>livraison professionnelle à Paris</strong> doivent être à la fois efficaces et écologiques.
                </p>
              </div>
            </section>

            {/* Section 2 */}
            <section className="mb-12">
              <h2 className="text-3xl font-bold text-gray-900 mb-6 flex items-center">
                <a href="#defis-paris" id="defis-paris" className="hover:text-teal-600 transition-colors">
                  Les défis du dernier kilomètre à Paris
                </a>
              </h2>
              
              <h3 className="text-2xl font-bold text-gray-900 mb-4">1. Congestion et restrictions de circulation</h3>
              <p className="text-gray-700 leading-relaxed mb-6">
                Paris impose des restrictions strictes : zones à faibles émissions (ZFE), horaires de livraison réglementés, stationnement limité. Ces contraintes obligent les <strong>transporteurs à Paris</strong> à optimiser leurs tournées et à utiliser des véhicules adaptés.
              </p>

              <h3 className="text-2xl font-bold text-gray-900 mb-4">2. Exigences de rapidité croissantes</h3>
              <p className="text-gray-700 leading-relaxed mb-6">
                Les clients parisiens attendent des livraisons express, souvent le jour même. Cette pression temporelle nécessite une organisation logistique irréprochable et des solutions de <Link to="/livraison-express-paris" className="text-teal-600 font-semibold hover:text-teal-700">livraison express à Paris</Link> performantes. Vous avez des questions ? Consultez notre <Link to="/#faq" className="text-teal-600 font-semibold hover:text-teal-700">FAQ transporteur express</Link>.
              </p>

              <h3 className="text-2xl font-bold text-gray-900 mb-4">3. Coûts opérationnels élevés</h3>
              <p className="text-gray-700 leading-relaxed mb-6">
                Entre le carburant, les péages, le stationnement et la main-d'œuvre qualifiée, le <strong>transport dernier kilomètre</strong> à Paris coûte 30 à 50% plus cher qu'en zone périurbaine. L'optimisation devient donc cruciale pour maintenir la rentabilité.
              </p>
            </section>

            {/* Tableau comparatif */}
            <section className="mb-12">
              <h2 className="text-3xl font-bold text-gray-900 mb-6 flex items-center">
                <a href="#solutions-comparaison" id="solutions-comparaison" className="hover:text-teal-600 transition-colors">
                  Comparaison des solutions de livraison à Paris
                </a>
              </h2>
              
              <div className="overflow-x-auto">
                <table className="w-full border-collapse bg-white shadow-lg rounded-lg overflow-hidden">
                  <thead className="bg-teal-600 text-white">
                    <tr>
                      <th className="px-6 py-4 text-left font-semibold">Solution</th>
                      <th className="px-6 py-4 text-left font-semibold">Rapidité</th>
                      <th className="px-6 py-4 text-left font-semibold">Coût</th>
                      <th className="px-6 py-4 text-left font-semibold">Écologie</th>
                      <th className="px-6 py-4 text-left font-semibold">Idéal pour</th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-gray-200">
                    <tr className="hover:bg-gray-50 transition-colors">
                      <td className="px-6 py-4 font-semibold text-gray-900">Coursier moto</td>
                      <td className="px-6 py-4 text-gray-700">⚡⚡⚡ Très rapide</td>
                      <td className="px-6 py-4 text-gray-700">€€€ Élevé</td>
                      <td className="px-6 py-4 text-gray-700">🌱🌱 Moyen</td>
                      <td className="px-6 py-4 text-gray-700">Plis urgents, petits colis</td>
                    </tr>
                    <tr className="hover:bg-gray-50 transition-colors">
                      <td className="px-6 py-4 font-semibold text-gray-900">Véhicule électrique</td>
                      <td className="px-6 py-4 text-gray-700">⚡⚡ Rapide</td>
                      <td className="px-6 py-4 text-gray-700">€€ Modéré</td>
                      <td className="px-6 py-4 text-gray-700">🌱🌱🌱 Excellent</td>
                      <td className="px-6 py-4 text-gray-700">Colis moyens, livraisons multiples</td>
                    </tr>
                    <tr className="hover:bg-gray-50 transition-colors">
                      <td className="px-6 py-4 font-semibold text-gray-900">Utilitaire classique</td>
                      <td className="px-6 py-4 text-gray-700">⚡ Standard</td>
                      <td className="px-6 py-4 text-gray-700">€ Économique</td>
                      <td className="px-6 py-4 text-gray-700">🌱 Faible</td>
                      <td className="px-6 py-4 text-gray-700">Gros volumes, déménagements</td>
                    </tr>
                    <tr className="hover:bg-gray-50 transition-colors">
                      <td className="px-6 py-4 font-semibold text-gray-900">Vélo cargo</td>
                      <td className="px-6 py-4 text-gray-700">⚡⚡ Rapide en centre</td>
                      <td className="px-6 py-4 text-gray-700">€ Économique</td>
                      <td className="px-6 py-4 text-gray-700">🌱🌱🌱 Excellent</td>
                      <td className="px-6 py-4 text-gray-700">Petits colis, courtes distances</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </section>

            {/* Section 3 */}
            <section className="mb-12">
              <h2 className="text-3xl font-bold text-gray-900 mb-6 flex items-center">
                <a href="#solutions-speed-transport" id="solutions-speed-transport" className="hover:text-teal-600 transition-colors">
                  Nos solutions pour optimiser votre dernier kilomètre
                </a>
              </h2>

              <div className="grid md:grid-cols-2 gap-6 mb-8">
                <div className="bg-white border-2 border-gray-200 rounded-lg p-6 hover:border-teal-500 transition-colors">
                  <div className="w-12 h-12 bg-teal-100 rounded-lg flex items-center justify-center mb-4">
                    <i className="ri-route-line text-2xl text-teal-600"></i>
                  </div>
                  <h3 className="text-xl font-bold text-gray-900 mb-3">Optimisation des tournées</h3>
                  <p className="text-gray-700 leading-relaxed">
                    Nos algorithmes de routage intelligent réduisent les distances parcourues de 25% et garantissent des livraisons ponctuelles dans toute la région parisienne.
                  </p>
                </div>

                <div className="bg-white border-2 border-gray-200 rounded-lg p-6 hover:border-teal-500 transition-colors">
                  <div className="w-12 h-12 bg-teal-100 rounded-lg flex items-center justify-center mb-4">
                    <i className="ri-truck-line text-2xl text-teal-600"></i>
                  </div>
                  <h3 className="text-xl font-bold text-gray-900 mb-3">Flotte adaptée</h3>
                  <p className="text-gray-700 leading-relaxed">
                    Motos, véhicules électriques, utilitaires : nous sélectionnons le véhicule optimal selon la nature de votre envoi et les contraintes de livraison.
                  </p>
                </div>

                <div className="bg-white border-2 border-gray-200 rounded-lg p-6 hover:border-teal-500 transition-colors">
                  <div className="w-12 h-12 bg-teal-100 rounded-lg flex items-center justify-center mb-4">
                    <i className="ri-time-line text-2xl text-teal-600"></i>
                  </div>
                  <h3 className="text-xl font-bold text-gray-900 mb-3">Livraison express 24/7</h3>
                  <p className="text-gray-700 leading-relaxed">
                    Service disponible jour et nuit, week-ends inclus. Idéal pour vos urgences et vos besoins de <Link to="/coursier-paris" className="text-teal-600 font-semibold hover:text-teal-700">coursier à Paris</Link>. Découvrez aussi notre article sur le <Link to="/blog/transport-urgent-weekend-paris" className="text-teal-600 font-semibold hover:text-teal-700">transport urgent le week-end</Link>.
                  </p>
                </div>

                <div className="bg-white border-2 border-gray-200 rounded-lg p-6 hover:border-teal-500 transition-colors">
                  <div className="w-12 h-12 bg-teal-100 rounded-lg flex items-center justify-center mb-4">
                    <i className="ri-map-pin-line text-2xl text-teal-600"></i>
                  </div>
                  <h3 className="text-xl font-bold text-gray-900 mb-3">Traçabilité en temps réel</h3>
                  <p className="text-gray-700 leading-relaxed">
                    Suivez vos colis en direct via notre système de géolocalisation. Notifications automatiques à chaque étape de la livraison.
                  </p>
                </div>
              </div>

              <div className="bg-gradient-to-r from-teal-50 to-emerald-50 border border-teal-200 rounded-lg p-8">
                <h3 className="text-2xl font-bold text-gray-900 mb-4">
                  Pourquoi choisir Speed Transport pour votre dernier kilomètre ?
                </h3>
                <ul className="space-y-3">
                  <li className="flex items-start">
                    <i className="ri-check-line text-teal-600 text-xl mr-3 mt-1"></i>
                    <span className="text-gray-700"><strong>Expertise locale :</strong> Connaissance parfaite de Paris et de ses contraintes logistiques</span>
                  </li>
                  <li className="flex items-start">
                    <i className="ri-check-line text-teal-600 text-xl mr-3 mt-1"></i>
                    <span className="text-gray-700"><strong>Flexibilité totale :</strong> Solutions sur-mesure adaptées à vos besoins spécifiques</span>
                  </li>
                  <li className="flex items-start">
                    <i className="ri-check-line text-teal-600 text-xl mr-3 mt-1"></i>
                    <span className="text-gray-700"><strong>Engagement écologique :</strong> Flotte de véhicules électriques et hybrides</span>
                  </li>
                  <li className="flex items-start">
                    <i className="ri-check-line text-teal-600 text-xl mr-3 mt-1"></i>
                    <span className="text-gray-700"><strong>Tarifs compétitifs :</strong> Devis gratuit et transparent, sans frais cachés</span>
                  </li>
                </ul>
              </div>
            </section>

            {/* Section 4 */}
            <section className="mb-12">
              <h2 className="text-3xl font-bold text-gray-900 mb-6 flex items-center">
                <a href="#tendances-futur" id="tendances-futur" className="hover:text-teal-600 transition-colors">
                  Les tendances du dernier kilomètre en 2024
                </a>
              </h2>
              <p className="text-gray-700 leading-relaxed mb-6">
                Le secteur de la <strong>logistique urbaine à Paris</strong> évolue rapidement. Voici les principales tendances qui transforment le dernier kilomètre :
              </p>

              <div className="space-y-6">
                <div className="flex items-start">
                  <div className="w-10 h-10 bg-teal-600 text-white rounded-full flex items-center justify-center font-bold mr-4 flex-shrink-0">
                    1
                  </div>
                  <div>
                    <h3 className="text-xl font-bold text-gray-900 mb-2">Électrification des flottes</h3>
                    <p className="text-gray-700 leading-relaxed">
                      Avec les restrictions ZFE, les véhicules électriques deviennent incontournables pour la <strong>livraison professionnelle à Paris</strong>. Speed Transport investit massivement dans cette transition.
                    </p>
                  </div>
                </div>

                <div className="flex items-start">
                  <div className="w-10 h-10 bg-teal-600 text-white rounded-full flex items-center justify-center font-bold mr-4 flex-shrink-0">
                    2
                  </div>
                  <div>
                    <h3 className="text-xl font-bold text-gray-900 mb-2">Micro-hubs urbains</h3>
                    <p className="text-gray-700 leading-relaxed">
                      Des centres de distribution de proximité permettent de réduire les distances et d'accélérer les livraisons dans les quartiers denses de Paris.
                    </p>
                  </div>
                </div>

                <div className="flex items-start">
                  <div className="w-10 h-10 bg-teal-600 text-white rounded-full flex items-center justify-center font-bold mr-4 flex-shrink-0">
                    3
                  </div>
                  <div>
                    <h3 className="text-xl font-bold text-gray-900 mb-2">Intelligence artificielle</h3>
                    <p className="text-gray-700 leading-relaxed">
                      L'IA optimise les tournées en temps réel en tenant compte du trafic, de la météo et des priorités de livraison pour un <strong>transport dernier kilomètre</strong> ultra-efficace.
                    </p>
                  </div>
                </div>
              </div>
            </section>

            {/* CTA Section */}
            <section className="bg-gradient-to-r from-teal-500 to-emerald-600 rounded-xl p-8 md:p-12 text-white text-center mb-12">
              <h2 className="text-3xl font-bold mb-4">
                Optimisez votre dernier kilomètre avec Speed Transport
              </h2>
              <p className="text-xl text-white/90 mb-8 max-w-2xl mx-auto">
                Confiez-nous vos livraisons à Paris et bénéficiez d'un service professionnel, rapide et écologique. Devis gratuit en 5 minutes.
              </p>
              <div className="flex flex-col sm:flex-row gap-4 justify-center">
                <a
                  href="tel:+33632410246"
                  className="inline-flex items-center justify-center bg-white text-teal-600 px-8 py-4 rounded-lg font-bold text-lg hover:bg-gray-50 transition-colors shadow-lg whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-phone-line mr-2"></i>
                  +33 6 32 41 02 46
                </a>
                <Link
                  to="/transport-paris"
                  className="inline-flex items-center justify-center bg-teal-700 text-white px-8 py-4 rounded-lg font-bold text-lg hover:bg-teal-800 transition-colors shadow-lg whitespace-nowrap cursor-pointer"
                >
                  Nos services
                  <i className="ri-arrow-right-line ml-2"></i>
                </Link>
              </div>
            </section>

            {/* Price Simulator */}
            <section className="mb-12">
              <PriceSimulator />
            </section>

            {/* Related Articles */}
            <section>
              <h2 className="text-3xl font-bold text-gray-900 mb-8">Articles connexes</h2>
              <div className="grid md:grid-cols-3 gap-6">
                {relatedArticles.map((article) => (
                  <Link
                    key={article.slug}
                    to={`/blog/${article.slug}`}
                    className="group bg-white rounded-lg overflow-hidden shadow-md hover:shadow-xl transition-shadow duration-300"
                  >
                    <div className="relative w-full h-48">
                      <img
                        src={article.image}
                        alt={article.title}
                        className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
                      />
                    </div>
                    <div className="p-4">
                      <h3 className="text-lg font-bold text-gray-900 group-hover:text-teal-600 transition-colors">
                        {article.title}
                      </h3>
                    </div>
                  </Link>
                ))}
              </div>
            </section>
          </div>
        </article>
      </div>

      <Footer />
    </>
  );
}
